import { useContext } from 'react';
import { AlertContext } from '../../providers/AlertModalProvider';

export default function useAlert() {
  return useContext(AlertContext);
}
